import { useState } from 'react';
import classnames from 'classnames';

import { Card } from 'ui-components/components/card/card';
import { StepCardTitle } from '../step-card-title';
import { StepCardBody } from '../step-card-body';
import { SetupConfigurationsReadOnly } from './setup-configurations-read-only';
import { SetupConfigurationsEdit } from './setup-configurations-edit';
import { useAdvancedShippingNoticeContext } from '../../advanced-shipping-notice-context';
import { SETUP_CONFIGURATION_STEP } from '../constants';
import { messages } from './messages';
import styles from '../step-card-body.module.less';

export const SetupConfigurationCard = () => {
  const {
    isEditingStepWithId,
    savedPayloads,
    isDraft,
    isCompleteStepWithId,
    isShippingConfigStepCollapsed,
    setIsShippingConfigStepCollapsed,
  } = useAdvancedShippingNoticeContext();
  const isEditing = isEditingStepWithId(SETUP_CONFIGURATION_STEP) && isDraft;
  const isComplete = isCompleteStepWithId(SETUP_CONFIGURATION_STEP);
  const [stepPayload, setStepPayload] = useState(savedPayloads[SETUP_CONFIGURATION_STEP]);
  const isDisabled = !isDraft || !(isEditing || isComplete);

  return (
    <Card
      className={classnames(styles['card-wrapper'], {
        [styles.disabled]: isDisabled,
      })}
    >
      <StepCardTitle
        isCollapsed={isShippingConfigStepCollapsed}
        setIsCollapsed={setIsShippingConfigStepCollapsed}
        stepId={SETUP_CONFIGURATION_STEP}
        stepPayload={stepPayload}
        titleMessageDescriptor={messages.setupConfigurationsTitle}
      />
      {!isShippingConfigStepCollapsed && (
        <StepCardBody stepId={SETUP_CONFIGURATION_STEP}>
          {isEditing && <SetupConfigurationsEdit setStepPayload={setStepPayload} stepPayload={stepPayload} />}
          {!isEditing && <SetupConfigurationsReadOnly stepPayload={stepPayload} />}
        </StepCardBody>
      )}
    </Card>
  );
};
